document.addEventListener('DOMContentLoaded', () => {
  console.log('wishlist.js domloaded');

  function swymCallbackFn() {
    console.log('swym callback');
    Shopify.Products.showRecentlyViewed({ howManyToShow: 4 });
    
    window._swat.fetch((r) => {
      const wishlistButtons = document.querySelectorAll(".add2wishlist");

      if (wishlistButtons) {
        wishlistButtons.forEach((button) => {
          const linkElem = button.querySelector("a");
          if (!linkElem) return;
          linkElem.addEventListener("click", (e) => {
            e.preventDefault();
          });

          const { variantid: epi, producturl: du, productid: empi, image: iu } = button.dataset;
          
          const found = r.some(elem => elem.epi == epi && elem.empi == empi);

          if (!found) {
            linkElem.classList.add("flag-action");
            linkElem.classList.remove("unflag-action");
          } else {
            linkElem.classList.remove("flag-action");
            linkElem.classList.add("unflag-action");
          }

          button.addEventListener("click", () => {
            window._swat.fetch((r) => {
              const found = r.some(elem => elem.epi == epi && elem.empi == empi);

              if (!found) {
                window._swat.addToWishList(getWishlistData(button), () => handleWishlistAction(linkElem, false));
              } else {
                window._swat.removeFromWishList(getWishlistData(button), () => handleWishlistAction(linkElem, true));
              }
            });
          });
        });
      }
    });
  }

  if (!window.SwymCallbacks) {
    window.SwymCallbacks = [];
  }

  window.SwymCallbacks.push(swymCallbackFn);

  function getWishlistData(button) {
    return {
      epi: button.dataset.variantid,
      du: `https://${window.Shopify.shop}${button.dataset.producturl}`,
      empi: button.dataset.productid,
      iu: button.dataset.image,
      dt: button.dataset.producttitle
    };
  }

  function handleWishlistAction(linkElem, isRemove) {
    const actionClass = isRemove ? "flag-action" : "unflag-action";
    linkElem.classList.toggle("flag-action", isRemove);
    linkElem.classList.toggle("unflag-action", !isRemove);
    console.log(`${isRemove ? 'Removed from' : 'Added to'} wishlist`);
  }
});
